import fn from '../lib/fn.js';
import { thousandSeparated } from '../lib/formatting.js';

const format = function (distance) {
    if (distance >= 1000) {
        return `${thousandSeparated(distance / 1000)} km`;
    }
    return `${thousandSeparated(distance)} m`;
};

export default {
    calculateSliderValue: fn.identity,
    formatFilterValue: fn.identity,
    formatStartLabel: format,
    formatEndLabel: format,
    format,
};
